"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var i18n_1 = require("./i18n");
var i18nAppProvider_1 = require("./i18nAppProvider");
var i18nTestProvider_1 = require("./i18nTestProvider");
var Interpolate_1 = require("./react-implementation/Interpolate");
exports.Interpolate = Interpolate_1.default;
var types_1 = require("./types");
exports.DefaultDateTimeFormat = types_1.DefaultDateTimeFormat;
exports.IntlDateFormatOptions = types_1.IntlDateFormatOptions;
exports.LanguageInitMap = types_1.LanguageInitMap;
exports.SupportedLanguages = types_1.SupportedLanguages;
var isEnvironmentJest_1 = require("./utils/isEnvironmentJest");
var i18nProvider = isEnvironmentJest_1.default() ? i18nTestProvider_1.default : i18nAppProvider_1.default;
var createI18nInstance = function (config) {
    var i18n = i18n_1.default(i18nProvider);
    i18n.initialize(config);
    return i18n;
};
exports.createI18nInstance = createI18nInstance;
var currency_1 = require("./localizers/currency");
exports.getMonetaryFields = currency_1.getMonetaryFields;
exports.formatMoney = currency_1.formatMoney;
exports.getDefaultCurrencySymbol = currency_1.getDefaultCurrencySymbol;
var getDefaultCurrency_1 = require("./localizers/getDefaultCurrency");
exports.getDefaultCurrency = getDefaultCurrency_1.getDefaultCurrency;
var getDefaultLocaleForCurrencySymbol_1 = require("./localizers/getDefaultLocaleForCurrencySymbol");
exports.getDefaultLocaleForCurrencySymbol = getDefaultLocaleForCurrencySymbol_1.getDefaultLocaleForCurrencySymbol;
var names_1 = require("./localizers/names");
exports.getLocalizedNames = names_1.getLocalizedNames;
var dates_1 = require("./localizers/dates");
exports.formatDateTime = dates_1.formatDateTime;
exports.formatTimeRange = dates_1.formatTimeRange;
exports.formatDateTimeFromIsoString = dates_1.formatDateTimeFromIsoString;
exports.formatTimeRangeFromIsoStrings = dates_1.formatTimeRangeFromIsoStrings;
var phoneNumber_1 = require("./localizers/phoneNumber");
exports.formatPhoneNumberToNational = phoneNumber_1.formatPhoneNumberToNational;
exports.formatPhoneNumberToInternational = phoneNumber_1.formatPhoneNumberToInternational;
exports.generatePhoneNumberComponents = phoneNumber_1.generatePhoneNumberComponents;
